module.exports = __webpack_public_path__ + "static/media/orion_logo_small.b9e0ee78.png";